
import { Link } from "react-router-dom";
import Logo from "@/components/common/Logo";

const Footer = () => {
  return (
    <footer className="mt-auto py-8 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col items-center md:items-start gap-3">
            <Logo size="small" />
            <a 
              href="https://play.google.com/store/apps/details?id=app.lovable.a458feef936a4fdd9306ef7eae220648"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform hover:scale-105"
            >
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
                className="h-10"
              />
            </a>
          </div>
          <div className="mt-4 md:mt-0 text-center md:text-right">
            <div className="text-muted-foreground text-xs mb-1">
              GoDyspo (also spelled GoDispo, Go Dyspo, or Go Dispo) — the real estate dispo platform.
            </div>
            <div className="text-muted-foreground text-sm mb-2">
              © {new Date().getFullYear()} Go Dyspo. All rights reserved.
            </div>
            <div className="flex flex-col sm:flex-row justify-center md:justify-end items-center gap-4 sm:gap-6">
              <Link 
                to="/consumer" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                Consumer Products
              </Link>
              <Link 
                to="/seller/faq" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                FAQ
              </Link>
              <Link 
                to="/contact" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                Contact Us
              </Link>
              <Link 
                to="/privacy-policy" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms-and-conditions" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
